import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import { Portal } from '../Portal/Portal';
import { colors } from '../../../styles/colors';
const Center = styled.div `
  min-height: calc(100% - 3.5rem);
  margin: 1.75rem auto;
  display: flex;
  align-items: center;
  transition: 0.3s;
`;
const ModalContainer = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: block;
  transition: 0.3s;
  z-index: ${(props) => props.zIndex};
  overflow: auto;
`;
const ModalComponentInner = styled.div `
  background: #ffffff;
  margin: 0 20px;
  border-radius: ${(props) => (props.nBr ? '0' : '8px')};
  border: 1px solid #e5e7eb;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  position: relative;
`;
const ModalComponent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px auto;
  cursor: auto;

  position: relative;
  span {
    position: absolute;
    right: 20px;
    top: 15px;
    cursor: pointer;
    z-index: 9999;
    font-size: 18px;
  }
`;
const ModalContainerNew = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.overlay};
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 99999;
  overflow: auto;
  padding: 24px;
`;
const ModalComponentInnerNew = styled.div `
  position: relative;
  margin: auto;
  border-radius: 20px;
  background: ${colors.surface};
  border: 1px solid ${colors.cardBorder};
  box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.5);
  z-index: 10000;
  overflow: hidden;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;

  ${({ eventModal }) => eventModal &&
    `
    margin: 0;
    border-radius: 0;
  `}

  ${({ lightShadow }) => lightShadow &&
    `
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.3);
  `}

  .close {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
    z-index: 9999;
    color: ${colors.textSecondary};
    transition: all 0.2s ease;

    &:hover {
      color: ${colors.textPrimary};
    }
  }
`;
export function Modal({ children, onClose, width, zIndex = '99999', mobMarg, close, nBr }) {
    const handleContainerClick = (e) => {
        if (e.currentTarget === e.target) {
            onClose();
        }
    };
    const handleModalClick = (e) => {
        e.stopPropagation();
    };
    return (_jsx(Portal, { children: _jsx(ModalContainer, Object.assign({ zIndex: zIndex, onClick: handleModalClick }, { children: _jsx(Center, Object.assign({ onClick: handleContainerClick }, { children: _jsx(ModalComponent, Object.assign({ width: width, mobMarg: mobMarg }, { children: _jsxs(ModalComponentInner, Object.assign({ nBr: nBr }, { children: [close && (_jsx("span", Object.assign({ role: "button", tabIndex: 0, className: "close", onKeyDown: () => null, onClick: (e) => {
                                    onClose();
                                } }, { children: "\u00D7" }), "modal")), children] })) })) })) })) }));
}
export function ModalNew({ children, onClose, close, eventModal, lightShadow }) {
    const handleContainerClick = (e) => {
        if (e.currentTarget === e.target) {
            e.stopPropagation();
            e.preventDefault();
            onClose();
        }
    };
    const handleModalClick = (e) => {
        e.stopPropagation();
    };
    return (_jsx(Portal, { children: _jsx(ModalContainerNew, Object.assign({ onClick: handleContainerClick }, { children: _jsxs(ModalComponentInnerNew, Object.assign({ onClick: handleModalClick, eventModal: eventModal, lightShadow: lightShadow }, { children: [close && _jsx(CloseIcon, { className: "close", onClick: onClose }), children] })) })) }));
}
Modal.defaultProps = {
    width: 0,
    zIndex: '99999',
    mobMarg: false,
    close: false,
    nBr: false,
};
ModalNew.defaultProps = {
    close: false,
    eventModal: false,
    lightShadow: false,
};
